import React, { PureComponent } from 'react';

class Moneda extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { tipoMoneda, monedaId,motivoAjusteDataFiltrado, ajusteEdicion } = this.props.ingresoAjuste;
        const { actions,permisos } = this.props;

        let monedaIdFiltrada = motivoAjusteDataFiltrado ?  motivoAjusteDataFiltrado.MonedaId : undefined;
        let comboHabilitados = (monedaIdFiltrada == 0 || monedaIdFiltrada == undefined) ? false : true;
        let value = comboHabilitados ? monedaIdFiltrada : monedaId;
        let permisoDeAlta = permisos && permisos.Alta && !comboHabilitados ? false : true;

        let optionMoneda = undefined;

        optionMoneda = tipoMoneda && tipoMoneda.length > 0 ? tipoMoneda.map((moneda, index) => {
            return (
                <option key={"moneda-opt" + index} value={moneda.Id}>
                    {moneda.Descripcion}
                </option>
            );
        }) : null; 


        return (
            <div className="row top-separator-xs">
                <div className="col-xs-5">
                    <label className="label-primary">Moneda *</label>
                    <select disabled={permisoDeAlta} className="form-control default-select" value={value}
                        onChange={(event) => {
                            actions.seleccionarMoneda(event.target.value)
                        }}>
                        {!ajusteEdicion ? <option value="0">Seleccione...</option> : null}
                        {optionMoneda}
                    </select>
                </div>
            </div>
        );
    }
}

export default Moneda;